export default "__VITE_ASSET__Cqi7Tmrs__"